import React, { ReactElement } from 'react'
import { TouchableOpacity, View } from 'react-native'
import { Text } from 'react-native-paper'
import CollapsableView from '@linqpal/common-frontend/src/ui/CollapsableView'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { TouchableWithoutFeedback } from 'react-native-gesture-handler'

interface ExpandableViewProps {
  title?: string
  titleStyle: any
  collapsedContainerStyle: any
  disabled?: boolean
  collapsableContent: any
  opened: boolean
  ExpandIcon?: ReactElement
  CollapseIcon?: ReactElement
  onExpanded?: (arg) => void
}

export default ({
  title,
  titleStyle,
  collapsedContainerStyle,
  disabled,
  collapsableContent,
  opened = false,
  ExpandIcon,
  CollapseIcon,
  onExpanded,
}: ExpandableViewProps) => {
  const [expanded, setExpanded] = React.useState(false)

  React.useEffect(() => {
    setExpanded(opened)
  }, [opened])

  React.useEffect(() => {
    if (onExpanded) {
      onExpanded(expanded)
    }
  }, [expanded, onExpanded])

  return (
    <TouchableWithoutFeedback
      onPress={() => setExpanded(!expanded)}
      disabled={disabled}
    >
      <View
        style={composeStyle(
          {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 3,
            backgroundColor: 'white',
            alignItems: 'center',
            paddingHorizontal: 20,
          },
          !expanded && collapsedContainerStyle,
        )}
      >
        <Text style={titleStyle}>{title}</Text>
        <TouchableOpacity onPress={() => setExpanded(!expanded)}>
          {expanded ? CollapseIcon : ExpandIcon}
        </TouchableOpacity>
      </View>
      <CollapsableView collapsed={!expanded}>
        {collapsableContent}
      </CollapsableView>
    </TouchableWithoutFeedback>
  )
}
